import { render, staticRenderFns } from "./BannerSwiper.vue?vue&type=template&id=3a4fa8c0&scoped=true&"
import script from "./BannerSwiper.vue?vue&type=script&lang=js&"
export * from "./BannerSwiper.vue?vue&type=script&lang=js&"
import style0 from "./BannerSwiper.vue?vue&type=style&index=0&id=3a4fa8c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4fa8c0",
  null
  
)

export default component.exports